import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import BaselineHelpOutline from 'react-md-icon/dist/BaselineHelpOutline';
import OpenInNew from 'react-md-icon/dist/BaselineOpenInNew';
import { ENHANCED_ESIGNATURE_URL } from '../../../../constants';

import { esignProductTierNames } from '../../../../constants/esignProductTierNames';

const TemplateHelp = (props) => {
  const { toggleHelpModal, selectedCompany, isDirectClient } = props;
  const companyIsSimpleSign = selectedCompany.esignatureProductTier.name === esignProductTierNames.SIMPLESIGN;
  const companyIsLegacy = selectedCompany.isEsignatureLegacyCompany;

  return (
    <Fragment>
      <div className="modal-header pt-0 pb-4 mx-n4 px-4">
        <div className="font-weight-light h4 mb-0">
          <BaselineHelpOutline viewBox="0 0 24 28" style={{ fontSize: '1.5rem', lineHeight: 1 }} />
          <div className="d-inline pl-1"><FormattedMessage id="SIGNATURE_OPTIONS" /></div>
        </div>
        <button className="btn btn-link" onClick={() => toggleHelpModal(true)}><FormattedMessage id="GO_BACK" /></button>
      </div>
      <Row className="pt-4">
        <Col>
          <FormattedMessage id="CHOOSE_THE_SIGNATURE_OPTION" />
        </Col>
      </Row>
      <Row className="pt-4">
        <Col>
          <strong><FormattedMessage id="NO_SIGNATURE" /></strong>
          <div><FormattedMessage id="HELP_NO_SIGNATURE" /></div>
        </Col>
      </Row>
      <Row className="pt-4">
        <Col>
          <strong><FormattedMessage id="SIMPLE_ESIGNATURE" /></strong>
          <div><FormattedMessage id="HELP_SIMPLE_ESIGNATURE_1" /></div>
          <div className="pt-4"><FormattedMessage id="HELP_SIMPLE_ESIGNATURE_2" /></div>
          <div className="pt-4"><FormattedMessage id="HELP_SIMPLE_ESIGNATURE_3" /></div>
        </Col>
      </Row>
      <Row className="pt-4">
        <Col>
          <strong><FormattedMessage id="ENHANCED_ESIGNATURE" /></strong>
          <div><FormattedMessage id="HELP_ENHANCED_ESIGNATURE_1" /></div>
          <div className="pt-4"><FormattedMessage id="HELP_ENHANCED_ESIGNATURE_2" /></div>
        </Col>
      </Row>
      {companyIsLegacy && companyIsSimpleSign ?
        <Row className="pt-3">
          <Col className="legacy-help mx-3 py-4">
            <strong><FormattedMessage id="NOTE" /></strong>&nbsp;
            <FormattedMessage id="HELP_LEGACY_1" />
            <div className="pt-4"><FormattedMessage id="HELP_LEGACY_2" /></div>
          </Col>
        </Row>
      :
          null
      }
      { isDirectClient ?
        <div className="pt-3">
          <a href={ENHANCED_ESIGNATURE_URL} target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="LEARN_MORE_ENHANCED_ESIGNATURE" />&nbsp;
            <div className="d-inline pl-1">
              <OpenInNew style={{ fontSize: '1.25rem', lineHeight: 1 }} />
            </div>
          </a>
        </div>
      : null }
    </Fragment>
  );
};

TemplateHelp.propTypes = {
  toggleHelpModal: PropTypes.func.isRequired,
  isDirectClient: PropTypes.bool.isRequired,
  selectedCompany: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    esignatureProductTier: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    isEsignatureLegacyCompany: PropTypes.bool,
  }).isRequired,
};

export default hot(module)(TemplateHelp);




// WEBPACK FOOTER //
// ./src/components/Forms/CreateTemplate/TemplateHelp/TemplateHelp.jsx